import store from "store";

export const set = () => {
    if (!process.env.WEBPACK) return;
    store.set("intervalsHint", "1");
};

export const get = () => {
    if (!process.env.WEBPACK) return false;
    return store.get("intervalsHint") ? true : false;
};
